import { SanityConfig } from '@/configs/sanity.config';
import createImageUrlBuilder from '@sanity/image-url';
import type { Image } from 'sanity';

export class SanityImageBuilder {
	private static builder = createImageUrlBuilder({
		projectId: SanityConfig.projectid,
		dataset:   SanityConfig.dataset,
	});

	static for(source: Image | undefined) {
		if (!source?.asset?._ref) return undefined;

		return this.builder.image(source);
	}
}